import mapOptionsToValue from '../constants/map-option-to-value';
import directions from '../constants/order-directions';
import normalizers from './normalize-by-field';

const compareByField = (field, left, right) =>
{
  if (left === undefined || right === undefined)
  {
    return 0;
  }

  const leftValue = left[field];
  const normalizedLeftValue = normalizers[field](leftValue);

  const rightValue = right[field];
  const normalizedRightValue = normalizers[field](rightValue);

  if (normalizedLeftValue > normalizedRightValue)
  {
    return 1;
  }

  if (normalizedLeftValue < normalizedRightValue)
  {
    return -1;
  }

  return 0;
};

const compareMap = {
  [directions.ASC]: compareByField,
  [directions.DESC]: (field, left, right) => -1 * compareByField(field, left, right)
};

const sortMap = {};
const definedOptions = Object.keys(mapOptionsToValue);

definedOptions.forEach((option) =>
{
  const { direction, field } = mapOptionsToValue[option];
  sortMap[option] = compareMap[direction].bind(null, field);
});

export default sortMap;